// eslint-disable-next-line
import tw from "twin.macro";
import React from "react";
import ProjectSection from "../components/Sections/ProjectSection/ProjectSection";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const project = () => {
  return (
    <Layout>
      <Seo title="Clients" description="Clients to our company" />
      <ProjectSection />
    </Layout>
  );
};

export default project;
